import { createClient } from '@supabase/supabase-js'

console.log('Supabase Environment Variables:', {
  url: import.meta.env.SUPABASE_URL,
  key: import.meta.env.SUPABASE_ANON_KEY?.substring(0, 20) + '...',
  mode: import.meta.env.MODE,
  dev: import.meta.env.DEV
})

export const supabase = createClient(
  import.meta.env.SUPABASE_URL,
  import.meta.env.SUPABASE_ANON_KEY
)
